import './spinner.scss';

const Spinner = ({absolute}) => {
    const formLoading = () => {
        if (absolute) {
            return {
                position: `absolute`,
                zIndex: 999,
                backgroundColor: `rgba(255, 255, 255, 0.8)`,
                top: 0,
                margin: 0,
                height: `100vh`,
                cursor: 'progress',
                overflow: 'hidden'
            };
        }

        return null;
    };

    return <div className="item" style={formLoading()}>
        <div className="loader"/>
    </div>;
};

export default Spinner;
